<template>
  <fin-data-loader :resolver="fetchData" fullpage>
    <template #content>
      <div :class="`fin-screener-result-list ${$vuetify.breakpoint.smAndDown ? 'mb-4': ''}`">

        <div
          v-if="selectedItems.length === 0 || ($route.name !== 'addScreenerInstrumentsToPortfolio' && $route.name !== 'addEtfScreenerInstrumentsToPortfolio')"
          class="fin-screener-table py-5">

          <div class="px-2 px-md-12 pb-4 pt-6">
            <h1>{{ screenerName }}</h1>
          </div>

          <div class="px-2 px-md-12" style="background-color: white;">
            <fin-subscription-content v-if="screener.inactive"
                                      :feature-id="screenerType === 'shareScreener' ? featureIds.SHARE_SCREENER.id : featureIds.ETF_SCREENER.id"
                                      :restriction-type="featureRestrictions.UNAVAILABLE"
                                      style="max-width: 700px;"/>

            <fin-add-to-watchlist :add-to-watchlist="addToWatchlist"
                                  :selected-instruments="selectedItems"
                                  @closeAddToWatchlist="addToWatchlist=false"
                                  v-if="!screener.inactive"
            />

            <div v-if="!screener.inactive">
              <v-row align="center">
                <template v-if="selectedItems.length > 0 && showNbOfSelectedItems === true">
                  <v-col cols="12" sm="6">
                    <p class="ma-0 nb-of-assets">
                      <v-btn @click="showNbOfSelectedItems = false" icon>
                        <v-icon style="font-size:20px">icon-close</v-icon>
                      </v-btn>
                      {{ selectedItems.length }} {{ selectedItems.length > 1 ? 'Assets' : 'Asset' }} ausgewählt
                    </p>
                  </v-col>

                  <v-col align="right" cols="12" sm="6">
                    <v-btn :disabled="isInactiveShareOrETF"
                           color="fin-color-primary-dark"
                           dark tile @click="addItemsToPortfolio">
                      Zu Portfolio hinzufügen
                    </v-btn>
                    <v-btn :color="$finColors.primaryDark"
                           :disabled="isInactiveShareOrETF"
                           class="ml-2"
                           icon
                           outlined
                           tile
                           @click="addToWatchlist=true">
                      <v-icon>icon-eye</v-icon>
                    </v-btn>
                  </v-col>
                </template>

                <template v-else-if="itemsTotal && itemsTotal > 0">
                  <v-col>
                    <p v-style:lineHeight="$vuetify.breakpoint.smAndDown ? '36px' : 'auto'"
                       class="ma-0 nb-of-items" style="line-height: 36px;">
                      {{ itemsTotal }} Ergebnisse
                    </p>
                    <v-btn v-if="$vuetify.breakpoint.smAndDown"
                           color="fin-color-primary-dark"
                           outlined
                           style="float: right;"
                           tile
                           @click="onEdit">
                      Screener bearbeiten
                    </v-btn>
                  </v-col>

                  <v-col v-if="screenerType === 'etfScreener'"
                         cols="12" md="6" offset-md="1">
                    <v-expansion-panels dense flat>
                      <v-expansion-panel style="border-radius: 0">
                        <v-expansion-panel-header class="screener-result-panel-header pa-0">
                          <p v-style:color="$finColors.primaryDark" class="mb-0"
                             style="font-weight: bold; display: contents; font-size: 14px;">Anzeige anpassen</p>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="screener-result-panel-content">
                          <!-- multi-select to choose columns to display in results of etf screener => array of strings -->
                          <fin-screener-dropdown-selector :items="etfScreenerColumns.categories"
                                                          :label="etfScreenerColumns.title"
                                                          :show-remove-icon="false"
                                                          :single-select="false"
                                                          :value="userDefinedColumns.map(item => getResultColumn(item))"
                                                          active-filter-prepend-label="Ausgewählte Spalten"
                                                          check-attribute="colId"
                                                          remove-all-active-filters-confirm-text="Möchtest du alle Spalten entfernen?"
                                                          remove-all-active-filters-confirm-title="Spalten entfernen"
                                                          @input="val => etfScreenerColumnsChanged(val)"/>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>

                  <v-col v-if="$vuetify.breakpoint.mdAndUp"
                         cols="3">
                    <v-btn @click="onEdit"
                           color="fin-color-primary-dark"
                           style="float: right;"
                           outlined
                           tile>
                      Screener bearbeiten
                    </v-btn>
                  </v-col>
                </template>
              </v-row>

              <fin-data-table v-model="selectedItems"
                              :headers="headers"
                              :height="540"
                              :resolver="getTableData"
                              :sort-by="sortByDefault"
                              :sort-desc="sortDescDefault"
                              fixed-header
                              showSelect
                              shrinkToViewPort
                              class="mt-6"
                              ref="screenerResultTable"
                              stickyFirstCol/>
            </div>
          </div>
        </div>

        <router-view :instruments="selectedItems" @addToPortfolioDone="setSelectedItems([])" v-else/>
      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import {finShareAPI, finEtfAPI, finUserAPI, finShareScreenerAPI, finEtfScreenerAPI, finScreenerAPI} from '@/js/finAPI'
import FinDataLoader from '@/components/common/DataLoader/index'
import FinAddToWatchlist from "../../../../common/Watchlists/AddToWatchlist"
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"
import FinScreenerDropdownSelector from "@/components/pages/finTools/finScreener/screenerMask/screenerDropdownSelector"
import FinSubscriptionContent from "@/components/common/subscription/content"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"

export default {
  name: 'FinScreenerResultList',
  components: {
    FinSubscriptionContent,
    FinScreenerDropdownSelector,
    FinAddToWatchlist,
    FinDataLoader,
    FinDataTable
  },
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      selectedItems: [],
      showNbOfSelectedItems: true,
      displayMode: 'selection',
      selector: false,
      addToWatchlist: false,
      screener: undefined,
      itemsTotal: 0,
      sortByDefault: ["col_nameWithIsin"],
      sortDescDefault: [true],
      groups: null, // needed only for etf screener
      screenerType: this.$route.path.includes('shareScreener') ? 'shareScreener' :
        this.$route.path.includes('etfScreener') ? 'etfScreener' : undefined,
      etfScreenerColumns: {}, // needed only for etf screener
      userChangedColumns: [], // needed only for etf screener
      headerLookupValues: {}, // needed only for etf screener
      featureIds: PRICEMODEL_FEATURE_IDS,
      featureRestrictions: PRICEMODEL_FEATURE_RESTRICTIONS,
    }
  },
  computed: {
    isInactiveShareOrETF() {
      let result = false
      if (this.selectedItems.some(e => e.active === false || e.covered === false || e.delisted === true)) {
        result = true
      }
      return result
    },
    screenerName() {
      let result = undefined
      if (this.screener) {
        result = this.screener.name
      }
      return result
    },
    // same implementation as in screenerMask\content\index.vue
    allSecondLevelFilter() {
      const result = []

      if (this.groups && this.groups.entries) {
        this.groups.entries.items.forEach(posgroup => {
          if (posgroup.isSubGroup) {
            posgroup.subPosGroup.entries.items.forEach(subPosGroup => {
              if (!subPosGroup.isSubGroup) {
                result.push(subPosGroup.dataItem)
              }
            })
          }
        })
      }

      return result
    },
    headers() {
      if (this.screener.inactive) {
        return []
      }

      if (this.screenerType === 'shareScreener') {
        let rangeFilterItems = this.screener.filters.items.map(item => item.item)
        let valueFilterItems = this.screener.valueFilters.items.map(item => item.item)
        let allFilters = [...new Set([...rangeFilterItems, ...valueFilterItems])]
        return TablePresets.createShareScreenerHeaders(allFilters)
      } else if (this.screenerType === 'etfScreener') {
        // columns needed as object such as {itemId, shortName, unit}
        let columns = []
        this.userDefinedColumns.forEach(column => {
          // 2 possibilities id:itemId / itemId
          const id = column.indexOf(':') === -1 ? column : column.substr(0, column.indexOf(':'))
          const itemId = column.indexOf(':') === -1 ? column : column.substr(column.indexOf(':') + 1)

          const res = this.allSecondLevelFilter.find(filterDef => filterDef.id === id && filterDef.itemId === itemId)
          if (res) {
            columns.push(res)
          }
        })

        const dividendTreatment = columns.find(c => c.id === 'dividendTreatment')
        if (dividendTreatment) {
          dividendTreatment.lookupValues = this.headerLookupValues.dividendTreatment
        }

        const etfSpecificGeo = columns.find(c => c.id === 'etfSpecificGeo')
        if (etfSpecificGeo) {
          etfSpecificGeo.lookupValues = this.headerLookupValues.etfSpecificGeo
          etfSpecificGeo.sortable = false
        }

        const hedgedInto = columns.find(c => c.id === 'hedgedInto')
        if (hedgedInto) {
          hedgedInto.lookupValues = this.headerLookupValues.hedgedInto
        }

        const leveragedLong = columns.find(c => c.id === 'leveragedLong')
        if (leveragedLong) {
          leveragedLong.lookupValues = this.headerLookupValues.leveragedLong
          leveragedLong.sortable = false
        }

        const leveragedShort = columns.find(c => c.id === 'leveragedShort')
        if (leveragedShort) {
          leveragedShort.lookupValues = this.headerLookupValues.leveragedShort
          leveragedShort.sortable = false
        }

        const short = columns.find(c => c.id === 'short')
        if (short) {
          short.lookupValues = this.headerLookupValues.short
          short.sortable = false
        }

        const sustainability = columns.find(c => c.id === 'sustainability')
        if (sustainability) {
          sustainability.lookupValues = this.headerLookupValues.sustainability
          sustainability.sortable = false
        }

        const fundFocus = columns.find(c => c.id === 'fundFocus')
        if (fundFocus) {
          fundFocus.lookupValues = this.headerLookupValues.fundFocus
          fundFocus.sortable = false
        }

        const commoditiesSector = columns.find(c => c.id === 'commoditiesSector')
        if (commoditiesSector) {
          commoditiesSector.lookupValues = this.headerLookupValues.commoditiesSector
          commoditiesSector.sortable = false
        }

        const operationalTime = columns.find(c => c.id === 'operationalTime')
        if (operationalTime) {
          operationalTime.lookupValues = this.headerLookupValues.operationalTime
          operationalTime.sortable = false
        }

        return TablePresets.createEtfScreenerHeaders(columns, this.$vuetify.breakpoint.mdAndDown)
      } else {
        console.error("failed to get headers, no such screener type", this.screenerType)
        return undefined
      }
    },
    userDefinedColumns() {
      return this.userChangedColumns.length > 0 ? this.userChangedColumns : this.screener.resultColumns
    },
  },
  methods: {
    async etfScreenerColumnsChanged(newCols) {
      // for "Region/Land" column, load lookup values
      if (newCols.find(c => c.colId === 'etfSpecificGeo:regionCountryCode') && !('etfSpecificGeo' in this.headerLookupValues)) {
        const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('etfSpecificGeo', this.screener.assetClass)
        this.headerLookupValues['etfSpecificGeo'] = result?.filterValues?.values
      }
      // for "Währungssicherung" column, load lookup values
      if (newCols.find(c => c.colId === 'hedgedInto:hedgedInto') && !('hedgedInto' in this.headerLookupValues)) {
        const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('hedgedInto', this.screener.assetClass)
        this.headerLookupValues['hedgedInto'] = result?.filterValues?.values
      }
      // for "Fokus" column, load lookup values
      if (newCols.find(c => c.colId === 'fundFocus:fundFocusCode') && !('fundFocus' in this.headerLookupValues)) {
        const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('fundFocus', this.screener.assetClass)
        this.headerLookupValues['fundFocus'] = result?.filterValues?.values
      }
      // for "Sektor" column, load lookup values
      if (newCols.find(c => c.colId === 'commoditiesSector:fundCategoryCode') && !('commoditiesSector' in this.headerLookupValues)) {
        const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('commoditiesSector', this.screener.assetClass)
        this.headerLookupValues['commoditiesSector'] = result?.filterValues?.values
      }
      // for "Laufzeit" column, load lookup values
      if (newCols.find(c => c.colId === 'operationalTime:fundNicheCode') && !('operationalTime' in this.headerLookupValues)) {
        const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('operationalTime', this.screener.assetClass)
        this.headerLookupValues['operationalTime'] = result?.filterValues?.values
      }

      // get new colIds
      this.userChangedColumns = newCols.map(c => c.colId)
      // save new colIds
      await finEtfScreenerAPI.updateEtfScreenerColumns(this.screener.id, this.userChangedColumns)
      // add the new colIds to the screener object + reload table data to show the new columns
      this.screener.resultColumns = this.userChangedColumns
      await this.$refs.screenerResultTable._fetchData()
    },
    getResultColumn(item) {
      const id = item.indexOf(':') === -1 ? item : item.substr(0, item.indexOf(':'))
      const col = this.etfScreenerColumns.categories.find(cat => cat.id === id)
      const name = col ? col.name : 'unbekannt'

      const itemId = item.indexOf(':') === -1 ? item : item.substr(item.indexOf(':') + 1)
      const colId = id === itemId ? id : id + ":" + itemId
      return {id, colId, itemId, name}
    },
    addItemsToPortfolio() {
      const routeName = this.screenerType === 'shareScreener' ? 'addScreenerInstrumentsToPortfolio' : 'addEtfScreenerInstrumentsToPortfolio'
      const paramsToName = this.screenerType === 'shareScreener' ? 'shareScreenerExecute' : 'etfScreenerExecute'
      this.$router.push({
        name: routeName,
        params: {
          //instruments: this.selectedItems,
          title: 'Wertpapier in Portfolio hinzufügen',
          to: {
            name: paramsToName,
            params: {id: this.id}
          }
        }
      })
    },
    onEdit() {
      this.$router.push({
        name: this.screenerType === 'shareScreener' ? 'shareScreenerEdit' : 'etfScreenerEdit',
        params: {id: this.$route.params.id}
      })
    },
    setSelectedItems(val) {
      this.selectedItems = val
      this.showNbOfSelectedItems = this.selectedItems.length > 0
    },
    async fetchData() {
      if (this.screenerType === 'shareScreener') {
        this.screener = await finUserAPI.getShareScreener(this.$route.params.id)
      } else if (this.screenerType === 'etfScreener') {
        this.screener = await finUserAPI.getEtfScreener(this.$route.params.id)
        this.groups = await finScreenerAPI.screenerPositionGroups(this.screener.assetClass)

        // for "Region/Land" column, load lookup values
        if (this.screener.resultColumns && this.screener.resultColumns.find(c => c === 'etfSpecificGeo:regionCountryCode')) {
          const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('etfSpecificGeo', this.screener.assetClass)
          this.headerLookupValues['etfSpecificGeo'] = result?.filterValues?.values
        }
        // for "Währungssicherung" column, load lookup values
        if (this.screener.resultColumns && this.screener.resultColumns.find(c => c === 'hedgedInto:hedgedInto')) {
          const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('hedgedInto', this.screener.assetClass)
          this.headerLookupValues['hedgedInto'] = result?.filterValues?.values
        }
        // for "Fokus" column, load lookup values
        if (this.screener.resultColumns && this.screener.resultColumns.find(c => c === 'fundFocus:fundFocusCode')) {
          const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('fundFocus', this.screener.assetClass)
          this.headerLookupValues['fundFocus'] = result?.filterValues?.values
        }
        // for "Sektor" column, load lookup values
        if (this.screener.resultColumns && this.screener.resultColumns.find(c => c === 'commoditiesSector:fundCategoryCode')) {
          const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('commoditiesSector', this.screener.assetClass)
          this.headerLookupValues['commoditiesSector'] = result?.filterValues?.values
        }
        // for "Laufzeit" column, load lookup values
        if (this.screener.resultColumns && this.screener.resultColumns.find(c => c === 'operationalTime:fundNicheCode')) {
          const result = await finEtfScreenerAPI.getFinancialDataItemFilterValues('operationalTime', this.screener.assetClass)
          this.headerLookupValues['operationalTime'] = result?.filterValues?.values
        }

        // dividendTreatment
        this.headerLookupValues.dividendTreatment = [{
          id: 'Capitalizes',
          name: 'thesaurierend'
        }, {
          id: 'Distributes',
          name: 'ausschüttend'
        }, {
          id: 'noValue',
          name: 'keine Angaben'
        }]
        // leveragedLong / short / sustainability
        const yesNoDash = [{
          id: 1,
          name: 'ja'
        }, {
          id: 0,
          name: 'nein'
        }, {
          id: 'noValue',
          name: '-'
        }]
        this.headerLookupValues.leveragedLong = yesNoDash
        this.headerLookupValues.leveragedShort = yesNoDash
        this.headerLookupValues.short = yesNoDash
        this.headerLookupValues.sustainability = yesNoDash

        this.etfScreenerColumns = {
          key: 'resultColumns',
          title: 'Spalten wählen',
          multiSelect: true,
          categories: this.allSecondLevelFilter.map(x => {
            return {
              id: x.id,
              itemId: x.itemId,
              colId: x.id + ":" + x.itemId,
              name: x.name,
            }
          }).sort((a, b) => a.name.localeCompare(b.name))
        }
      } else {
        console.error("failed to fetchData, cause: no such screener type", this.screenerType)
      }
    },
    async getTableData(options) {
      let {sortBy, sortDesc, page, itemsPerPage} = options
      if (!sortBy || sortBy.length <= 0) {
        sortBy = ["name"]
        sortDesc = [true]
      }
      const params = {
        from: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        sort: sortBy?.length > 0 ? {field: sortBy[0], direction: sortDesc[0] ? 'asc' : 'desc'} : null,
      }

      let resultSet = undefined
      if (this.screenerType === 'shareScreener') {
        resultSet = await finShareAPI.secondFilterShareScreenerShares(this.screener, params)
      } else if (this.screenerType === 'etfScreener') {
        resultSet = await finEtfAPI.secondFilterEtfScreenerEtfs(this.screener, params)
      } else {
        console.error("getTableData no such screener type", this.screenerType)
      }

      this.itemsTotal = resultSet ? resultSet.total : 0

      if (this.screener.lastHits !== this.itemsTotal) {
        this.screener.lastHits = this.itemsTotal
        if (this.screenerType === 'shareScreener') {
          await finShareScreenerAPI.updateShareScreenerHits(this.screener.id, this.itemsTotal)
        } else if (this.screenerType === 'etfScreener') {
          await finEtfScreenerAPI.updateEtfScreenerHits(this.screener.id, this.itemsTotal)
        }
      }

      return resultSet ? resultSet : []
    }
  },
}
</script>

<style lang="scss" scoped>
.nb-of-items {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
}

.nb-of-assets {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
}

.fin-screener-add-to-portfolio {
  background-color: #ffffff;
}

.screener-result-panel-header {
  min-height: 36px;
}

.screener-result-panel-header ::v-deep .v-expansion-panel-header__icon {
  margin-left: 12px;
}

.screener-result-panel-header ::v-deep .v-expansion-panel-header__icon i {
  color: $fin-color-primary-dark;
  font-weight: bold;
}

.screener-result-panel-content ::v-deep .v-expansion-panel-content__wrap {
  padding: 20px 0 0;
}
</style>
